import { render, staticRenderFns } from "./ProductMovement-page.vue?vue&type=template&id=b5256ba8&scoped=true&"
import script from "./ProductMovement-page.vue?vue&type=script&lang=js&"
export * from "./ProductMovement-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5256ba8",
  null
  
)

export default component.exports